export default __webpack_public_path__ + "static/media/screenhacker_01.2b08c4ca.png";